import SubscriptionCardRepository from "../SubscriptionCardRepository"

export default class PricingProfessionalSubscription extends SubscriptionCardRepository {
    static schemaId = "pricing_card2"

    constructor() {
        super(PricingProfessionalSubscription.schemaId)
    }
}
